import "./style.css";
import resume from "../../img/resume/Ihar_Skavysh.pdf";
const Header = () => {
  return (
    <header className="header">
      <div className="header__wrapper">
        <h1 className="header__title">
          <strong>
            Hi, my name is <em>Ihar</em>
          </strong>
          <br />a frontend developer
        </h1>
        <div className="header__text">
          <p>with passion for learning and creating.</p>
        </div>
        <a href={resume} download="resume(Ihar Skavysh).pdf" className="btn">
          Download CV
        </a>
      </div>
    </header>
  );
};

export default Header;
